import React from 'react';
import Phone from '../SVGs/Phone';
import SMS from '../SVGs/SMS';
import WEB from '../SVGs/WEB';

const TariffUsageDetail = ({usageDetail = null}) => {
  const determineTitle = (usageType) => {
    switch (usageType) {
      case 'Voice':
        return 'שיחות לאחר סיום החבילה';
      case 'Sms':
        return 'SMS לאחר סיום החבילה';
      case 'Data':
        return 'גלישה לאחר סיום החבילה';
    }
  };
  const determineIcon = (usageType) => {
    switch (usageType) {
      case 'Voice':
        return <Phone />;
      case 'Sms':
        return <SMS />;
      case 'Data':
        return <WEB />;
    }
  };
  let returned = '';
  if (usageDetail != null) {
    returned = (
      <div className='TariffDetails'>
        <div className='IconContainer'>{determineIcon(usageDetail.category)}</div>
        <div className='UsageSection'>
          <div className='UsageText'>{usageDetail.title}</div>
          <div className='UsageData'>
            <span className='UsageAmount'>
              {usageDetail.usage} {usageDetail.unit}
            </span>
            <span className='UsagePrice'>₪{usageDetail.price}</span>
          </div>
        </div>
      </div>
    );
  }
  return returned;
};

export default TariffUsageDetail;
